/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesMatchStatusSchema = z.enum([
  "Scheduled",
  "Ready",
  "Pending",
  "Live",
  "Completed",
  "Cancelled",
  "Paused",
]);
